import React from 'react';
import { useSystemTradingServers } from '../hooks/use-system-trading-servers.js';
import SystemTradingServersPageView from './system-trading-servers-page-view.jsx';

function SystemTradingServersPageContainer() {
  const state = useSystemTradingServers();
  return <SystemTradingServersPageView {...state} />;
}

export default SystemTradingServersPageContainer;

